import { Close, LockReset, ErrorOutline } from '@mui/icons-material'
import { forwardRef } from 'react'
import { Box, Dialog, Fab, ListItem, Slide, Switch, Grid, Button, Typography, Chip } from '@mui/material'
import usersRoutes from '../routes/users.routes'
import { dateWithTime } from '../config'
import { useNotificationsContext, useAlertContext } from '../context'
import { normalizeRutDisplay } from '../containers/users-list/UsersList'

const Transition = forwardRef(function Transition (props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const UserListDataDialog = ({ open, userModal, handleChange, checked, closeModal, setstatus, notificationId }) => {
    const { resolveNotification } = useNotificationsContext()
    const { setConfirm } = useAlertContext()

    const handleResetPassword = async () => {
        // Obtenemos solo el cuerpo numérico del RUT como configuramos en el backend
        const rutBody = userModal.rut.split('-')[0]
        const passwordDefault = rutBody.replace(/\D/g, '')

        setConfirm(
            'Restablecer Contraseña',
            `¿Está seguro de restablecer la contraseña de este usuario? clave temporal: ${passwordDefault}`,
            async () => {
                setstatus({
                    status: 'loading',
                    title: 'Restableciendo contraseña',
                    message: 'Por favor espere mientras se actualizan las credenciales...'
                })

                try {
                    const response = await usersRoutes.resetPassword(userModal._id || userModal.id)
                    if (response.status === 201 || response.status === 200) {
                        if (notificationId) {
                            await resolveNotification(notificationId)
                        }

                        setstatus({
                            status: 'completed',
                            severity: 'success',
                            title: 'Contraseña restablecida',
                            message: `La contraseña del usuario ${userModal.name} ${userModal.lastName} ha sido restablecida`
                        })
                        closeModal(userModal)
                    }
                } catch (error) {
                    console.error('Error reset password:', error)
                    setstatus({
                        status: 'error',
                        title: 'Error al restablecer',
                        message: error.response?.data?.message || 'No se pudo completar la operación. Intente nuevamente.'
                    })
                }
            }
        )
    }

    return (
        <Dialog
            open={open}
            onClose={() => closeModal(userModal)}
            TransitionComponent={Transition}
            maxWidth="sm"
            fullWidth
        >
            <Box style={{ padding: 20 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: 'brown' }}>Datos del Usuario</Typography>
                    {notificationId && (
                        <Chip
                            icon={<ErrorOutline />}
                            label="Solicitud de Clave Pendiente"
                            color="warning"
                            variant="outlined"
                            sx={{ fontWeight: 700, animation: 'pulse-destacado 2s infinite', mr: 5 }}
                        />
                    )}
                </Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ p: 1, wordBreak: 'break-word' }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#555' }}>Nombre y Apellido</Typography>
                            <Typography variant="body2">{userModal.name} {userModal.lastName}</Typography>
                            <Box sx={{ mt: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#555' }}>Rol del usuario</Typography>
                                <Typography variant="body2">{userModal.role?.name || userModal.role}</Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ p: 1, wordBreak: 'break-word' }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#555' }}>Email</Typography>
                            <Typography variant="body2">{userModal.email || 'Sin correo'}</Typography>
                            <Box sx={{ mt: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#555' }}>RUN</Typography>
                                <Typography variant="body2">{normalizeRutDisplay(userModal.rut)}</Typography>
                            </Box>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Box sx={{ px: 1, mt: 1, borderTop: '1px solid #f0f0f0', pt: 2 }}>
                            <Typography variant="caption" sx={{ color: '#888' }}>
                                <strong>Última modificación:</strong> {dateWithTime(userModal.updatedAt)}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', alignItems: 'center', px: 1 }}>
                            <Switch onChange={handleChange} checked={checked} size="small" />
                            <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
                                {checked ? 'Usuario activo' : 'Usuario inactivo'}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: 10 }}>
                        <Button
                            variant="contained"
                            color="warning"
                            fullWidth
                            startIcon={<LockReset />}
                            onClick={handleResetPassword}
                            sx={{ py: 1.5, fontWeight: 700 }}
                        >
                            Restablecer Contraseña
                        </Button>
                    </Grid>
                </Grid>
                <Fab onClick={() => closeModal(userModal)} style={{ position: 'absolute', right: 10, top: 10, boxShadow: 'none', backgroundColor: 'transparent' }}>
                    <Close style={{ color: '#ccc' }} />
                </Fab>
            </Box>
        </Dialog>
    )
}

export default UserListDataDialog
